/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  CardBody,
  Row,
  Col,
  CardHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Breadcrumb,
  BreadcrumbItem,
  ButtonGroup,
  Input,
  ModalFooter,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import axios from 'axios';
import { api } from '../../config';
import { getAuthToken, isAuthenticated } from '../../auth/tokenvalidation';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ProcurementView.css';
import metaMask from '../../assets/images/nft/newrecord.png';
import Select from 'react-select';
import ProductHydro from './component/ProductHydro';
import HydrocarbonCondensat from './component/HydrocarbonCondensat';

const TABS = [
  {
    id: 'product-hydro',
    label: 'Product Hydro',
    icon: 'ri-drop-line',
    component: ProductHydro,
  },
  {
    id: 'hydrocarbon-condensat',
    label: 'Hydrocarbon & Condensate',
    icon: 'ri-test-tube-line',
    component: HydrocarbonCondensat,
  },
];

const ProcurementList = () => {
  const navigate = useNavigate();
  const token = getAuthToken();
  const [activeTab, setActiveTab] = useState('product-hydro');
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const { user } = useSelector(state => state.Login);
  const userRoles = user?.role?.split(',').map(r => r.trim()) || [];
  const hasKPI = userRoles.includes('KPI');
  const hasPPN = userRoles.includes('PPN');
  const onlyKPI = hasKPI && !hasPPN;
  const onlyPPN = !hasKPI && hasPPN;
  const showBoth = (hasKPI && hasPPN) || (!hasKPI && !hasPPN);
  const showProductHydro = onlyPPN || showBoth;
  const showHydroCondensate = onlyKPI || showBoth;

  const visibleTabs = TABS.filter(tab => {
    if (tab.id === 'product-hydro') return showProductHydro;
    if (tab.id === 'hydrocarbon-condensat') return showHydroCondensate;
    return true;
  });

  useEffect(() => {
    const defaultTab = onlyKPI ? 'hydrocarbon-condensat' : 'product-hydro';
    if (!visibleTabs.find(t => t.id === activeTab)) {
      setActiveTab(visibleTabs[0]?.id || defaultTab);
    }
    if (onlyKPI) {
      setActiveTab('hydrocarbon-condensat');
    }
  }, [onlyKPI, onlyPPN]);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  // Authentication validation
  useEffect(() => {
    if (!token) {
      toast.error('Authentication token not found. Please login again.');
      return;
    }
    if (!isAuthenticated()) {
      toast.error('Please login to access this page.');
      return;
    }
  }, [token]);

  const [modal, setModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    titleProcurement: '',
    procurementType: '',
    description: '',
    procurementTypeHeader: '',
  });

  const procurementtype = [
    {
      options: [
        { label: 'Pelelangan Khusus', value: 'PelelanganKhusus' },
        { label: 'Pemilihan Langsung', value: 'PemilihanLangsung' },
        { label: 'Tunjuk Langsung', value: 'TunjukLangsung' },
      ],
    },
  ];

  const handleprocurementTypeChange = selectedOption => {
    setFormData({ ...formData, procurementType: selectedOption.value });
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleTypeChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateFields = () => {
    let tempErrors = {};
    if (!formData.titleProcurement) {
      tempErrors.titleProcurement = 'Please Enter Title';
    }

    if (!formData.procurementTypeHeader) {
      tempErrors.procurementTypeHeader = 'Please Select Procurement Type';
    }
    if (!formData.procurementType) {
      tempErrors.procurementType = 'Please Select ';
    }
    if (!formData.description) {
      tempErrors.description = 'Please Enter Description';
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const closeModal = () => {
    setFormData({
      titleProcurement: '',
      procurementType: '',
      description: '',
      procurementTypeHeader: '',
    });
    setErrors({});
    setModal(!modal);
  };

  const handleSubmit = async e => {
    if (validateFields()) {
      e.preventDefault();
      try {
        const response = await axios.post(
          `${api.API_URL}/procurement`,
          formData,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.id) {
          toast.success('Data Has Been Saved');
          navigate(`/apps-procurement/upd/${response.id}`);
        } else {
          toast.error('Failed to save data. Check server response.');
        }
      } catch (error) {
        toast.error(`Failed to save data: ${error.message}`);
      }
    }
  };

  const togglemodal = useCallback(() => {
    setFormData({
      titleProcurement: '',
      procurementType: '',
      description: '',
      procurementTypeHeader: activeTab === 'product-hydro' ? '1' : '2',
    });
    setModal(prev => !prev);
  }, [activeTab]);

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} />
      <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4 pb-0'>
            <div className='border-bottom border-bottom-dashed'>
              <Row className='mt-n2 mb-1 mb-sm-0'>
                <div className='col-sm order-3 order-sm-2'>
                  <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                    <h5 className='card-title mb-0 flex-grow-1 '>
                      <Breadcrumb listClassName='p-3 py-2 bg-light'>
                        <BreadcrumbItem>
                          {' '}
                          <Link to='#'> Home </Link>{' '}
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                          {' '}
                          <Link to='#'> Plan & Procurement </Link>{' '}
                        </BreadcrumbItem>
                        <BreadcrumbItem active> View </BreadcrumbItem>
                      </Breadcrumb>
                    </h5>
                  </div>
                </div>
                <div className='col-auto order-2 order-sm-3 '>
                  <div className='d-flex gap-sm-1 email-topbar-link '>
                    <button
                      type='button'
                      className='btn btn-ghost-secondary material-shadow-none btn-icon btn-sm fs-16'
                      onClick={handleRefresh}
                    >
                      <i className='ri-refresh-line align-bottom'></i>
                    </button>
                  </div>
                </div>
              </Row>

              <Row className='row align-items-end mt-1 mb-1'>
                <Col xs={12}>
                  <CardHeader className='border-0'>
                    <div className='d-flex align-items-center flex-wrap'>
                      <h5 className='card-title mb-0 flex-grow-1 text-uppercase'>
                        Planning & Procurement
                      </h5>

                      <div className='flex-shrink-0'>
                        <div className='d-flex gap-2 flex-wrap'>
                          <button
                            type='button'
                            className='btn btn-primary btn-label right ms-auto nexttab btn-sm'
                            onClick={togglemodal}
                          >
                            <i className='ri-add-fill label-icon align-middle fs-16 ms-2'></i>{' '}
                            <span className='d-none d-sm-inline'>
                              Create New
                            </span>
                            <span className='d-sm-none'>New</span>
                          </button>

                          <ButtonGroup>
                            <UncontrolledDropdown>
                              <DropdownToggle
                                tag='button'
                                className='btn btn-light btn-label right ms-auto nexttab btn-sm'
                              >
                                Export{' '}
                                <i className=' ri-file-list-2-line label-icon align-middle fs-16 ms-2'></i>{' '}
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem>Export to Excel</DropdownItem>
                                <DropdownItem>Export to CSV</DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </ButtonGroup>
                        </div>
                      </div>
                    </div>
                  </CardHeader>
                </Col>
              </Row>
            </div>

            <div className='message-list-content mx-n4 px-4 message-list-scroll'>
              <Nav tabs className='nav-tabs-custom nav-primary mt-3 mb-0'>
                {visibleTabs.map(tab => (
                  <NavItem key={tab.id}>
                    <NavLink
                      className={classnames('cursor-pointer', {
                        active: activeTab === tab.id,
                      })}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <i className={`${tab.icon} align-middle me-1`}></i>
                      <span className='fw-semibold'>{tab.label}</span>
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              <TabContent activeTab={activeTab} className='pt-3'>
                {visibleTabs.map(tab => {
                  const TabComponent = tab.component;
                  return (
                    <TabPane key={tab.id} tabId={tab.id}>
                      <TabComponent refreshTrigger={refreshTrigger} />
                    </TabPane>
                  );
                })}
              </TabContent>
            </div>
          </div>
        </div>
      </div>

      <Modal
        size='lg'
        isOpen={modal}
        role='dialog'
        autoFocus={true}
        centered
        id='addAddressModal'
        toggle={togglemodal}
        data-bs-backdrop='static'
        className='modal-fullscreen-sm-down'
      >
        <ModalHeader
          className='bg-soft-info p-3'
          toggle={() => {
            setModal(!modal);
          }}
        ></ModalHeader>

        <ModalBody>
          <div className='d-flex mt-1'>
            <Col xxl={12}>
              <div>
                <Row className='justify-content-center mb-1'>
                  <Col lg={12} className='text-center'>
                    <img
                      src={metaMask}
                      alt=''
                      height='65'
                      className='mb-2 pb-2'
                    />
                    <h5>Create New Planning & Procurement </h5>
                    <p className='text-muted pb-1'>
                      Start a new procurement request by filling in the details
                      below.
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className='mb-2 bor border-top  border-top-dashed '></div>
                  </Col>
                </Row>
                <Row className='mb-2'>
                  <Label htmlFor='titleProcurement' className='form-label'>
                    Procurement Type
                  </Label>
                  {showProductHydro && (
                    <Col lg={4}>
                      <div className='form-check card-radio'>
                        <Input
                          id='procurementTypeHeader01'
                          name='procurementTypeHeader'
                          type='radio'
                          value='1'
                          className='form-check-input'
                          onChange={e => {
                            handleTypeChange(e);
                            setErrors({
                              ...errors,
                              procurementTypeHeader: null,
                            });
                          }}
                          checked={
                            parseInt(formData.procurementTypeHeader, 10) === 1
                          }
                        />
                        <Label
                          className='form-check-label'
                          for='procurementTypeHeader01'
                          style={{
                            backgroundColor:
                              parseInt(formData.procurementTypeHeader, 10) === 1
                                ? 'rgba(13, 110, 253, 0.12)'
                                : '',
                            borderColor:
                              parseInt(formData.procurementTypeHeader, 10) === 1
                                ? '#405189'
                                : '#e2e5e8',
                            borderWidth: '1px',
                          }}
                        >
                          <span className='fs-16 me-2'>
                            <i className='ri-file-list-2-line align-bottom'></i>
                          </span>
                          <span className='fs-15 mb-1 text-wrap'>
                            Product Hydro
                          </span>
                        </Label>
                      </div>
                      {errors.procurementTypeHeader && (
                        <div className='text-danger d-flex align-items-center gap-1'>
                          <i className='mdi mdi-alert-circle-outline'></i>
                          <span>{errors.procurementTypeHeader}</span>
                        </div>
                      )}
                    </Col>
                  )}
                  {showHydroCondensate && (
                    <Col lg={4}>
                      <div className='form-check card-radio'>
                        <Input
                          id='procurementTypeHeader02'
                          name='procurementTypeHeader'
                          type='radio'
                          value='2'
                          className='form-check-input'
                          onChange={e => {
                            handleTypeChange(e);
                            setErrors({
                              ...errors,
                              procurementTypeHeader: null,
                            });
                          }}
                          checked={
                            parseInt(formData.procurementTypeHeader, 10) === 2
                          }
                        />
                        <Label
                          className='form-check-label'
                          for='procurementTypeHeader02'
                          style={{
                            backgroundColor:
                              parseInt(formData.procurementTypeHeader, 10) === 2
                                ? 'rgba(13, 202, 240, 0.12)'
                                : '',
                            borderColor:
                              parseInt(formData.procurementTypeHeader, 10) === 2
                                ? '#299cdb'
                                : '#e2e5e8',
                            borderWidth: '1px',
                          }}
                        >
                          <span className='fs-16 me-2'>
                            <i className='ri-file-list-2-line align-bottom'></i>
                          </span>
                          <span className='fs-15 mb-1 text-wrap'>
                            Hydro & Condensate
                          </span>
                        </Label>
                      </div>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col sm={12} md={6}>
                    <div className='mb-1'>
                      <Label htmlFor='titleProcurement' className='form-label'>
                        Title Procurement
                      </Label>
                      <Input
                        type='text'
                        className='form-control '
                        id='titleProcurement'
                        name='titleProcurement'
                        placeholder='Enter Title Procurement'
                        onChange={e => {
                          handleChange(e);
                          setErrors({
                            ...errors,
                            titleProcurement: '',
                          });
                        }}
                      />
                    </div>
                    {errors.titleProcurement && (
                      <div className='text-danger d-flex align-items-center gap-1'>
                        <i className='mdi mdi-alert-circle-outline'></i>
                        <span>{errors.titleProcurement}</span>
                      </div>
                    )}{' '}
                  </Col>
                  <Col sm={12} md={6}>
                    <div className='mb-1'>
                      <span
                        htmlFor='choices-publish-status-input'
                        className='form-label'
                      >
                        Proc Type{' '}
                      </span>

                      <Select
                        name='procurementType'
                        id='procurementType'
                        placeholder='-- Please Select --'
                        options={procurementtype}
                        onChange={e => {
                          handleprocurementTypeChange(e);
                          setErrors({
                            ...errors,
                            procurementType: '',
                          });
                        }}
                      />
                    </div>
                    {errors.procurementType && (
                      <div className='text-danger d-flex align-items-center gap-1'>
                        <i className='mdi mdi-alert-circle-outline'></i>
                        <span>{errors.procurementType}</span>
                      </div>
                    )}{' '}
                  </Col>
                </Row>

                <Row>
                  <Col sm={12}>
                    <div>
                      <Label
                        htmlFor='exampleFormControlTextarea5'
                        className='form-label'
                      >
                        Description{' '}
                      </Label>
                      <textarea
                        className='form-control'
                        id='description'
                        name='description'
                        onChange={e => {
                          handleChange(e);
                          setErrors({
                            ...errors,
                            description: '',
                          });
                        }}
                        rows='5'
                      ></textarea>
                    </div>
                    {errors.description && (
                      <div className='text-danger d-flex align-items-center gap-1'>
                        <i className='mdi mdi-alert-circle-outline'></i>
                        <span>{errors.description}</span>
                      </div>
                    )}{' '}
                  </Col>
                </Row>
              </div>
            </Col>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className='hstack gap-2 justify-content-end d-print-none mt-4 flex-wrap'>
            <button
              color='primary'
              type='button'
              className='btn btn-primary flex-fill flex-sm-grow-0'
              onClick={closeModal}
            >
              <i className='ri-logout-box-line align-bottom me-1'></i>Close
            </button>
            <button
              type='submit'
              className='btn btn-primary btn-label right ms-auto nexttab flex-fill flex-sm-grow-0'
              onClick={handleSubmit}
            >
              <i className='ri-arrow-right-line label-icon align-middle fs-16 ms-2'></i>{' '}
              Next
            </button>
          </div>
        </ModalFooter>
      </Modal>

      <ToastContainer closeButton={false} limit={1} />
    </React.Fragment>
  );
};

export default React.memo(ProcurementList);
